import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-01/lesson-23/task-02";

const task: Slide = {
  titleHtml:
    "The A-weighting coefficients are provided in the table and allows to correct the<br>instrument-measured sound levels in an effort to account for the relative loudness<br>perceived by the human ear, which frequency response is not flat.",
  description: "Select correctly calculated A-weighted levels and the overall level in dB A.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/23/task/task-2.svg`,
                },
              },
              styles: {
                padding: "1%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
